import Constants, {UserTypes} from '../../globals/Constants';
import Store from '../../redux/Store';
import Actions from '../../redux/Actions';
import UserModel from '../../types/UserModel';
import UsersModel from '../../types/UsersModel';
import WebConnectorUserInfo from '../../types/WebConnectorUserInfo';
import FeedbackUserService from '../FeedbackUserService/FeedbackUserService';
import ServerUserModel from '../../types/ServerUserModel';

const setUserInfo = async (userInfo: WebConnectorUserInfo): Promise<any> => {
   const currentUsers: UsersModel = Store.getState().users || {};
   const newUser: UserModel = {
      userId: userInfo.id,
      email: userInfo.email,
      avatarUrl: userInfo.profileImageUrl,
      name: userInfo.displayName,
      isDeleted: false,
      userType: UserTypes.techSmith
   };

   const allUsers = Object.assign({}, currentUsers, {[userInfo.id]: newUser});
   Store.dispatch(Actions.setUsers(allUsers));

   await FeedbackUserService.getNotificationSettings(userInfo.id);
   await FeedbackUserService.getReviewerGroups();
   return;
};

const setUsers = async (users: ServerUserModel[]): Promise<UsersModel> => {
   const currentUsers: UsersModel = Store.getState().users || {};
   const allUsers: UsersModel = currentUsers;
   users.forEach(u => {
      if (allUsers[u.Id] && allUsers[u.Id].email && (!u.EmailAddress || !u.UserType)) {
         return;
      }
      allUsers[u.Id] = {
         userId: u.Id,
         name: u.DisplayName || u.EmailAddress || Constants.user.failedName,
         email: u.EmailAddress,
         avatarUrl: returnAvatarUrlIfNotDefault(u.ProfileImageUrl),
         userType: u.UserType,
         isDeleted: u.IsUserDeleted
      };
   });

   Store.dispatch(Actions.setUsers(allUsers));

   return allUsers;
};

const returnAvatarUrlIfNotDefault = (avatarUrl: string): string => {
   return avatarUrl && avatarUrl.indexOf(Constants.user.identifyDefaultAvatarFileName) === -1 ? avatarUrl : null;
};

export default {
   setUsers,
   setUserInfo,
   returnAvatarUrlIfNotDefault
};
